import { Fragment, PureComponent } from 'react'
import PropTypes from 'prop-types'

import { Button, Column, Form, Input, Link, Modal } from '../../..'
import { layerForm as layerFormProps } from '../../../../types'
import Expander from '../../../Expander'
import ChainList from './ChainList'
const { FormGroup, FormHeader, Label } = Form

class PlaylistsForm extends PureComponent {
    static propTypes = {
        errors: PropTypes.shape({
            name: PropTypes.string,
            date_start: PropTypes.string,
            date_end: PropTypes.string,
            chain_id: PropTypes.arrayOf(PropTypes.number),
        }),
        isOpen: PropTypes.bool,
        isWorking: PropTypes.bool,
        values: PropTypes.shape(layerFormProps),
        onChangeForm: PropTypes.shape({
            name: PropTypes.func,
            date_start: PropTypes.func,
            date_end: PropTypes.func,
            chain_id: PropTypes.func,
        }),
        onClickCancel: PropTypes.func,
        onClickSubmit: PropTypes.func,
        onClickNullStartDate: PropTypes.func.isRequired,
        onClickNullEndDate: PropTypes.func.isRequired,
        onClickRemoveStartDate: PropTypes.func.isRequired,
        onClickRemoveEndDate: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
    }

    static defaultProps = {
        errors: {
            name: null,
            date_start: null,
            date_end: null,
            chain_id: null,
        },
        isOpen: false,
        isWorking: false,
        values: {},
        onChangeForm: {
            name: () => null,
            date_start: () => null,
            date_end: () => null,
            chain_id: () => null,
        },
        onClickCancel: () => null,
        onClickSubmit: () => null,
    }

    renderStartDateLabel() {
        const { onClickRemoveStartDate, t } = this.props

        return (
            <Fragment>
                {t('date-start')}
                &nbsp;
                <Link onClick={onClickRemoveStartDate}>&times;</Link>
            </Fragment>
        )
    }

    renderEndDateLabel() {
        const { onClickRemoveEndDate, t } = this.props

        return (
            <Fragment>
                {t('date-end')}
                &nbsp;
                <Link onClick={onClickRemoveEndDate}>&times;</Link>
            </Fragment>
        )
    }

    render() {
        const { errors, isOpen, isWorking, onChangeForm, onClickCancel, onClickSubmit, onClickNullStartDate, onClickNullEndDate, values, t } = this.props
        const { name: errorName, date_start: errorDateStart, date_end: errorDateEnd, slug: errorSlug } = errors
        const { name, date_start, date_end, slug, chain_id } = values
        const { name: onChangeName, date_start: onChangeDateStart, date_end: onChangeDateEnd, slug: onChangeSlug, chain_id: onChangeChainId } = onChangeForm

        return (
            <Modal isOpen={isOpen} onClose={onClickCancel}>
                <Form>
                    <FormHeader>{t('New Playlist')}</FormHeader>
                    <FormGroup title={t('Playlist')}>
                        <Label id="name" label={t('Playlist Name')} error={errorName}>
                            <Input id="name" name="name" type="text" error={!!errorName} onChange={onChangeName} size="md" value={name} />
                        </Label>
                        <Label id="chain" label="Select Chains">
                            <ChainList id="chains" name="chains" onChange={onChangeChainId} size="md" value={chain_id} />
                        </Label>
                        <Expander icon="cogs" header={t('Advanced options')}>
                            <Label id="slug" description={t('slug-description')} label={t('slug')} error={errorSlug}>
                                <Input id="slug" name="slug" type="text" error={!!errorSlug} onChange={onChangeSlug} size="md" value={slug} />
                            </Label>
                        </Expander>
                    </FormGroup>
                    <FormGroup title={t('schedule')}>
                        {date_start && (
                            <Label id="date_start" label={this.renderStartDateLabel()} error={errorDateStart}>
                                <Input
                                    id="date_start"
                                    name="date_start"
                                    type="date"
                                    error={!!errorDateStart}
                                    onChange={onChangeDateStart}
                                    value={date_start}
                                    withTime
                                />
                            </Label>
                        )}
                        {!date_start && (
                            <div>
                                <Link onClick={onClickNullStartDate}>{t('date-start-add')}</Link>
                            </div>
                        )}
                        {date_end && (
                            <Label id="date_end" label={this.renderEndDateLabel()} error={errorDateEnd}>
                                <Input id="date_end" name="date_end" type="date" error={!!errorDateEnd} onChange={onChangeDateEnd} value={date_end} withTime />
                            </Label>
                        )}
                        {!date_end && (
                            <div>
                                <Link onClick={onClickNullEndDate}>{t('date-end-add')}</Link>
                            </div>
                        )}
                    </FormGroup>
                    <div className="modal-bottom">
                        <FormGroup>
                            <Column right width="100%">
                                <Button theme="secondary" onClick={onClickCancel} size="sm" disabled={isWorking}>
                                    {t('Cancel')}
                                </Button>
                                <Button onClick={onClickSubmit} size="sm" theme={isWorking ? 'loading' : 'forestGreen'} disabled={isWorking}>
                                    {isWorking ? '...' : t('Create')}
                                </Button>
                            </Column>
                        </FormGroup>
                    </div>
                </Form>
            </Modal>
        )
    }
}

export default PlaylistsForm
